module.exports = __webpack_public_path__ + "img/u19.9822ab62.png";